<template>
  <Modal
    data-testid="details-modal"
    class="details-modal"
    size="md"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <Heading :level="3">{{ data?.title }}</Heading>
    <BaseText class="details-modal__description" size="p5">
      {{ data?.description }}
    </BaseText>
    <div class="details-modal__details">
      <ListDisplay
        v-for="(item, index) in data?.rows"
        :key="index"
        class="details-modal__details-item"
        :title="item.label"
        :value="item.value"
        :has-divider="index !== data.rows.length - 1"
      />
    </div>
    <div v-if="data?.banner" class="details-modal__banner">
      <BaseText
        class="details-modal__banner-title"
        :color="NebraskaColors.elementPrimary"
        size="p4"
      >
        {{ data?.banner?.title }}
      </BaseText>
      <BaseText size="p5">
        {{ data?.banner?.description }}
      </BaseText>
      <ButtonPrimary
        :label="data?.banner?.button.label"
        class="details-modal__banner-button"
        @click="handleBannerAction(data?.banner?.button.action)"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import {
  Modal,
  Heading,
  BaseText,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IAmountDetails , BannerAction } from '@/modules/trade/services/margin-allocation';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { useRouter } from 'vue-router/composables';

interface Props {
  isOpen: boolean;
  data: IAmountDetails;
}
defineProps<Props>();

const router = useRouter();

const handleBannerAction = (action: BannerAction) => {
  switch (action) {
    case BannerAction.GO_TO_AMW_CASH_CLASH:
      router.push({
        name: 'productsCatalog',
        params: {
          type: 'funds',
          productId: 'c9c94d27-9f23-11ec-929c-0aae9b4e6433'
        }
      });
      break;
  }
};
</script>
<style lang="less" scoped>
.details-modal {
  :deep(.base-modal--wrapper) {
    width: 592px;
    max-width: 592px;
  }

  :deep(.modal-content) {
    align-items: flex-start;
    padding: 0 @size-spacing-x1000 @size-spacing-x1000;
    text-align: left;
  }

  &__description {
    margin-top: @size-spacing-x450;
  }

  &__details {
    margin-top: @size-spacing-x600;

    &-item {
      margin-bottom: @size-spacing-x350;
    }
  }

  &__banner {
    background-color: @background-tertiary;
    border-radius: @size-radius-x200;
    margin-top: @size-spacing-x600;
    padding: @size-spacing-x450;
  }

  &__banner-title {
    font-weight: 600;
    margin-bottom: @size-spacing-x350;
  }

  &__banner-button {
    margin-top: @size-spacing-x450;
    width: 100%;
  }
}
</style>
